import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {LeadTecsinapse} from "../_model/lead-tecsinapse";

@Injectable({
  providedIn: 'root',
})
export class LeadTecsinapseService {
  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
  }

  salvarLead( form: LeadTecsinapse): Observable<LeadTecsinapse> {

    return this.http.post<LeadTecsinapse>(
      `${ environment.URL_API_LEADS_DIGITAL }/Lead/tecsinapse`,
      form,
    );
  }
}
